import { render } from "./FixtureSelect.vue?vue&type=template&id=5fa1dd0b"
import script from "./FixtureSelect.vue?vue&type=script&lang=js"
export * from "./FixtureSelect.vue?vue&type=script&lang=js"

import "./FixtureSelect.vue?vue&type=style&index=0&id=5fa1dd0b&lang=css"

import exportComponent from "C:\\Users\\HS\\Desktop\\fikstur\\my_fiksture\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__